import { useEffect, useState } from 'react';
import './HomeComponents.css';

const LandingHero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const phoneImages = ['/assets/asset1.jpg', '/assets/asset2.jpg', '/assets/asset3.jpg'];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % 3);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const getPosition = (index: number) => {
    const offset = (index - currentIndex + 3) % 3;
    if (offset === 0) return 'center';
    if (offset === 1) return 'right';
    return 'left';
  };

  const redirectToDeviceStore = (platform: 'android' | 'ios') => {
    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isAndroid = /android/i.test(ua);
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
    const androidLink = "https://play.google.com/store/apps/details?id=com.olitask.app";
    const iosLink = "https://apps.apple.com/us/app/olitask/id6756482938";
    const deepLink = "oliveeb://open";

    if (platform === 'android') {
      if (isAndroid) {
        window.location.href = deepLink;
        setTimeout(() => { window.location.href = androidLink; }, 1500);
      } else {
        window.open(androidLink, "_blank");
      }
    } else {
      if (isIOS) {
        window.location.href = deepLink;
        setTimeout(() => { window.location.href = iosLink; }, 1500);
      } else {
        window.open(iosLink, "_blank");
      }
    }
  };

  return (
    <section className="landing-home" id="top-home">
      <video className="hero-video-bg" autoPlay muted loop playsInline>
        <source src="/assets/vid 3.mp4" type="video/mp4" />
      </video>

      <div className="landing-skyline">
        <svg viewBox="0 0 1440 200" preserveAspectRatio="none">
          <path fill="#22c55e" d="M0,160 L60,140 L100,150 L140,120 L180,130 L220,100 L280,110 L320,80 L360,90 L400,60 L450,70 L500,40 L550,50 L600,30 L650,40 L700,20 L750,30 L800,15 L850,25 L900,10 L950,20 L1000,8 L1050,18 L1100,5 L1150,15 L1200,3 L1250,12 L1300,2 L1350,10 L1400,5 L1440,0 L1440,200 L0,200 Z"/>
        </svg>
      </div>

      <div className="content-card">
        <div className="landing-content">
          <div className="landing-text">
            <img className="landing-logo" src="/assets/logo1.png" alt="Olitask" />
            <h1>Get things done with <span>local helpers</span></h1>
            <p className="landing-subtext">
              Connect with trusted local helpers in your area. From running errands to home repairs — Olitask makes it easy to get help when you need it and in time.
            </p>
            <p className="landing-download-label">Download App</p>
            <div className="hero-buttons">
              <button className="btn-download-android" onClick={() => redirectToDeviceStore('android')}>
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/>
                </svg>
                Download for Android
              </button>
              <button className="btn-download-ios" onClick={() => redirectToDeviceStore('ios')}>
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                Download for iOS
              </button>
            </div>
          </div>

          <div className="landing-visual">
            <div className="landing-phone-carousel">
              {phoneImages.map((img, idx) => (
                <div key={idx} className={`landing-phone-card ${getPosition(idx)}`}>
                  <div className="landing-phone-frame">
                    <img src={img} alt={`Phone ${idx + 1}`} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingHero;